/**
 * Integrytas Group — PageHeader (common).
 *
 * The Direction-D list/form page header: a title (24/700, −0.4 tracking) with a
 * one-line description (13/ink-3) on the left, and right-aligned actions on the
 * right — ghost buttons (`btn-secondary`) then a single primary (`btn-primary`),
 * per the page skeleton in design/desktop/README.md.
 *
 * Compose it as the first row of a page's canvas:
 *   <div className="flex flex-col gap-[18px] p-6">
 *     <PageHeader title={…} description={…} actions={…} />
 *     <StatStrip stats={…} />
 *     <ContentCard>…toolbar / grid / footer…</ContentCard>
 *   </div>
 */

import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  /** Right-aligned actions — ghost buttons then one primary. */
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <h1 className="text-csm-title text-csm-ink">{title}</h1>
        {description && <p className="text-csm-page-desc text-csm-muted">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
